require("exports-loader?window.iframely!./embed.js");
module.exports = window.iframely;
